import { sendEvent } from '@civitime/game-server/lib/saga-tools/Data.effects'

export function * sendLeaderboard(command){
  yield sendEvent("LeaderboardSent", { points: command.points })
}

export function * sendFinalLeaderboard(command){
  yield sendEvent("FinalLeaderboardSent", {})
}